export default class Mission {
    constructor(api) {
        this._ready = false;
        this.missionHash = {};
        this.api = api;
    }

    h(name) {
        return this.missionHash[name];
    }
    fetchAll() {
        return this.api.fetchAllMission()
            .then(data => {
                this._ready = true;
                parseMissionHash(this.missionHash, data.missions);
                return data.missions;
            })
    }
    fetch() {
        return this.api.fetchMission()
            .then(data => {
                parseMissionHash(this.missionHash, data);
                this._ready = true;
                return this.missionHash;
            })
    }

    complete(name, player_game_id, quantity) {
        if (!this.isReady()) {
            throw 'Hệ thống nhiệm vụ chưa sẵn sàng';
        }
        this.h(name).isProcessing = true;
        return this.api.missionComplete(name, player_game_id, quantity)
            .then(data => {
                return name;
            })
    }

    canDo(name) {
        if (!isReady()) return false;
        if (!isProcessing(name)) return false;
        if (!isDone(name)) return false;
        return true;
    }

    isProcessing(name) {
        if (!isReady()) return false;
        return (this.h(name).isProcessing);
    }

    isDone(name) {
        if (!isReady()) return false;
        return this.h(name).isDone;
    }

    isReady() {
        return this._ready;
    }

    waitToReady() {
        return new Promise((r, _) => {
            setInterval(() => {
                if (this.isReady()) return r(true);
            }, 10)
        })
    }

    get(name) {
        return this.h(name)
    }

    getAll() {
        return Object.keys(this.missionHash).map(key => this.missionHash[key]);
    }

    getAllNames() {
        return Object.keys(this.missionHash);
    }
}

function parseMissionHash(missionHash, missions) {
    if (typeof missions !== 'object') {
        return;
    }
    missions.forEach(function(mission) {
        missionHash[mission.name] = mission;
    })
}